import ButtonLink from "../../components/button-link";
import classes from "../../classes";
import ConfirmBox from "../../components/confirm-box";
import creditCardBack from "../../../public/images/credit-card-back.png";
import expandable from "../../components/higher-order/expandable";
import FormError from "../../components/form-error";
import leftPad from "../../left-pad";
import { Map } from "immutable";
import { range } from "../../as-range";
import React from "react";
import visaMastercardLogos from "../../../public/images/logos/visa-mastercard-logo.jpg";

export default class CreditCardForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedCard: props.session.getIn(["credit_cards", 0, "id"]) || "new-credit-card"
    };
    this.onChangeCard = this.onChangeCard.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onChangeCard(e) {
    this.setState({ selectedCard: e.target.value }); // eslint-disable-line react/no-set-state
  }

  onSubmit(e) {
    var { deposit, history, onDepositNewCreditCard, onDepositSavedCreditCard, session } = this.props;
    var { selectedCard } = this.state;

    e.preventDefault();

    if (this.getSelectedCard() === "new-credit-card") {
      onDepositNewCreditCard(
        session.get("user_id"),
        deposit.get("firstName"),
        deposit.get("lastName"),
        deposit.get("cardNumber"),
        deposit.get("expMonth"),
        deposit.get("expYear"),
        deposit.get("cvv"),
        deposit.get("amount"),
        deposit.get("rememberCard"),
        history
      );
    } else {
      onDepositSavedCreditCard(
        session.get("user_id"),
        selectedCard,
        deposit.get("amount"),
        history
      );
    }
  }

  getSelectedCard() {
    var { session } = this.props;
    var { selectedCard } = this.state;
    if (selectedCard !== "new-credit-card" && session.get("credit_cards").filter(cc => cc.get("id") === selectedCard).count() === 0) {
      selectedCard = session.getIn(["credit_cards", 0, "id"]) || "new-credit-card";
    }
    return selectedCard;
  }

  render() {
    var { communications, deposit, onDeleteCreditCard, session, setDepositCreditCard } = this.props;

    var selectedCard = this.getSelectedCard();

    var ccs = session.get("credit_cards").map(cc => (
      <SavedCreditCard
        creditCard={cc}
        key={cc.get("id")}
        onChange={this.onChangeCard}
        onDelete={onDeleteCreditCard}
        selected={selectedCard === cc.get("id")}
        userId={session.get("user_id")} />
    ));

    var loading = communications.getIn(["credit_card_deposit", "state"]) === "in progress";

    var errors = communications.getIn(["credit_card_deposit", "error"]) || Map();
    var newCCForm;
    if (selectedCard === "new-credit-card") {
      newCCForm = <NewCreditCardForm deposit={deposit} errors={errors} setDepositCreditCard={setDepositCreditCard} />;
    }

    return (
      <form className="form--is-horizontal display--fade-in" data-target="panel-credit-card" onSubmit={this.onSubmit}>
        <div className="batch-g batch-g--padding batch-g--valign-center">

          <div className="batch-c-1-1 batch-c-md-1-4 text-right hidden--mobile">
            <img height="30" src={visaMastercardLogos} />
          </div>

          <div className="batch-c-1-1 batch-c-md-3-4">
            <h3>
              <div className="display--is-inline-block visible--mobile vertical-align--is-middle padding-right--is-5">
                <img height="30" src={visaMastercardLogos} />
              </div>

              <span>
                Credit Card
              </span>
            </h3>
          </div>

          <div className="batch-c-1-1 batch-c-md-1-4" />

          <div className="batch-c-1-1 batch-c-md-3-4">
            <ul>
              {ccs}

              <li>
                <label className="label--radio" htmlFor="radio-credit-card-4">
                  <input
                    checked={selectedCard === "new-credit-card"}
                    id="radio-credit-card-4"
                    name="credit-card-options"
                    onChange={this.onChangeCard}
                    type="radio"
                    value="new-credit-card" />

                  <span>
                    Use a new Credit Card.
                  </span>
                </label>
              </li>
            </ul>
          </div>

          {newCCForm}

          <div className="batch-c-1-1 batch-c-md-1-4" />

          <div className="batch-c-1-1 batch-c-md-3-4">
            <p className="note-text">
              Credit cards are subject to a 2.99% surcharge fee. There is no surcharge for debit cards or ACH transactions.
            </p>
          </div>

          <div className="batch-c-1-1 batch-c-md-1-4" />

          <div className="batch-c-1-1 batch-c-md-3-4">
            <div className="form_action">
              <input
                className={classes({
                  "btn": true,
                  "btn--primary": true,
                  "btn--is-loading": loading,
                })}
                disabled={loading}
                type="submit"
                value={loading ? "Processing" : "Deposit From Credit Card"} />
            </div>
          </div>

        </div>
      </form>
    );
  }
}

class NewCreditCardForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    var field = e.target.name;
    var value;
    switch (e.target.type) {
      case "checkbox":
        value = e.target.checked;
        break;
      default:
        value = e.target.value;
        break;
    }
    var { setDepositCreditCard } = this.props;
    setDepositCreditCard(field, value);
  }

  render() {
    var { deposit, errors } = this.props;

    var monthOptions = range(1, 12).map(month => (
      <option key={month} value={month}>
        {leftPad(month, 2)}
      </option>
    ));
    var currentYear = new Date().getYear() + 1900;
    var yearOptions = range(currentYear, currentYear + 20).map(year => (
      <option key={year}>
        {year}
      </option>
    ));

    return (
      <div className="batch-g batch-g--padding batch-g--valign-center">
        <div className="batch-c-1-1 batch-c-md-1-4">
          <label htmlFor="firstName">
            Name on Card
          </label>
        </div>

        <div className="batch-c-1-1 batch-c-md-3-4">
          <div className="batch-g">
            <div className="batch-c-1-2 padding-right--is-10">
              <input className="form_input" id="firstName" name="firstName" onChange={this.onChange} placeholder="First Name" type="text" value={deposit.get("firstName")} />

              <FormError error={errors.get("first_name")} name="First Name" />
            </div>

            <div className="batch-c-1-2">
              <input className="form_input" id="lastName" name="lastName" onChange={this.onChange} placeholder="Last Name" type="text" value={deposit.get("lastName")} />

              <FormError error={errors.get("last_name")} name="Last Name" />
            </div>
          </div>
        </div>

        <div className="batch-c-1-1 batch-c-md-1-4">
          <label htmlFor="cardNumber">
            Card Number
          </label>
        </div>

        <div className="batch-c-1-1 batch-c-md-3-4">
          <input className="form_input" id="cardNumber" name="cardNumber" onChange={this.onChange} placeholder="Card Number" type="number" value={deposit.get("cardNumber")} />

          <FormError error={errors.get("card_number")} name="Card Number" />
        </div>

        <div className="batch-c-1-1 batch-c-md-1-4">
          <label htmlFor="expMonth">
            Expiration Date
          </label>
        </div>

        <div className="batch-c-1-1 batch-c-md-3-4">
          <div className="form_input form_input--select">
            <select id="expMonth" name="expMonth" onChange={this.onChange} value={deposit.get("expMonth")}>
              <option disabled value="">
                - Month -
              </option>

              {monthOptions}
            </select>

            <FormError error={errors.get("exp_month")} name="Exp. Month" />
          </div>

          <div className="form_input form_input--select">
            <select id="expYear" name="expYear" onChange={this.onChange} value={deposit.get("expYear")}>
              <option disabled value="">
                - Year -
              </option>

              {yearOptions}
            </select>

            <FormError error={errors.get("exp_year")} name="Exp. Year" />
          </div>
        </div>

        <div className="batch-c-1-1 batch-c-md-1-4">
          <label htmlFor="cvv">
            Security Code
          </label>
        </div>

        <div className="batch-c-1-4 batch-c-md-1-6">
          <input className="form_input" id="cvv" maxLength="4" name="cvv" onChange={this.onChange} placeholder="123" type="number" value={deposit.get("cvv")} />

          <FormError error={errors.get("cvv")} name="CVV" />
        </div>

        <div className="batch-c-1-4 batch-c-md-1-8">
          <img className="display--is-block margin-bottom--is-10-mobile padding-left--is-5-mobile" height="39" src={creditCardBack} />
        </div>

        <div className="batch-c-1-2 batch-c-md-11-24">
          <div className="note-text margin-bottom--is-10-mobile">
            Last 3 digits on back of card.
          </div>
        </div>

        <div className="batch-c-1-1 batch-c-md-1-4" />

        <div className="batch-c-1-1 batch-c-md-3-4">
          <label className="label--inline" htmlFor="remember-card">
            <input checked={deposit.get("rememberCard")} id="remember-card" name="rememberCard" onChange={this.onChange} type="checkbox" value="remember-card" />

            <span>
              Remember card for future use.
            </span>
          </label>
        </div>
      </div>
    );
  }
}

var SavedCreditCard = expandable(function SavedCreditCard({ creditCard, expanded, onChange, onDelete, selected, toggle, userId }) {
  var confirm;
  if (expanded) {
    var onConfirm = (e) => {
      e.preventDefault();
      onDelete(userId, creditCard.get("id"));
      toggle();
    };
    confirm = (
      <ConfirmBox confirmMessage="Yes, Delete Payment Method" onCancel={toggle} onConfirm={onConfirm}>
        Are you sure you want to delete the credit card ending in
        {" "}

        {creditCard.get("last_digits")}
        ?
      </ConfirmBox>
    );
  }
  return (
    <li>
      <label className="label--radio">
        <input
          checked={selected}
          name="credit-card-options"
          onChange={onChange}
          type="radio"
          value={creditCard.get("id")} />

        <span>
          Use saved Credit Card ending in
          {" "}

          <span className="text--is-bold">
            {creditCard.get("last_digits")}
          </span>

          {"." /* eslint-disable-line react/jsx-curly-brace-presence */ }
        </span>
      </label>

      <ButtonLink className="text-small color--is-action" onClick={toggle}>
        Delete
      </ButtonLink>

      {confirm}
    </li>
  );
});
